import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TableBase} from '../table-base';
import {TYPE_DATA} from '../../../models/table';


@Component({
  selector: 'cmp-input-table',
  template: `<div [ngSwitch]="key.type_data" class="w-100 text-center" (click)="clickBoolCustom()">
  <!--******* INIT BOOLEAN *******-->
  <ng-template [ngSwitchCase]="enum_type_data.BOOLEAN">

    <!--  BOOLEAN CUSTOM IF ADD IN ARRAY ITEM VALUE_DROPDOW   -->
    <ng-template
      [ngIf]="key && key.value_DROPDOWN && key.value_DROPDOWN.length"
      [ngIfElse]="booleanDefault">
      <span *ngIf="customBoolean">
        <i [class]="customBoolean.icon + ' '+ customBoolean.style_icon"></i>
        <span *ngIf=" customBoolean.title">{{customBoolean.title}}</span>
      </span>
      <span *ngIf="!customBoolean">
        <i class="fa fa-minus text-muted"></i>
      </span>
    </ng-template>


    <!--  BOOLEAN DEFAULT LOAD IF NOTHING ITEMS IN VALUE_DROPDOWN   -->
    <ng-template #booleanDefault>
      <cmp-input-check [(model)]="model" (modelChange)="model = $event; filterBySearch()"></cmp-input-check>
    </ng-template>

  </ng-template>
  <!--******* END BOOLEAN *******-->

  <!--******* INIT DATA NUMBER *******-->
  <ng-template [ngSwitchCase]="enum_type_data.NUMBER">
    <cmp-input (modelChange)="model = $event; filterBySearch()"
               [_type]="enum_type_data.NUMBER"
               [(model)]="model"></cmp-input>
  </ng-template>

  <!--******* END DATA NUMBER *******-->

  <!--******* INIT DATA BY DATE FORMAT *******-->
  <ng-template [ngSwitchCase]="enum_type_data.DATE">
    <cmp-input-date (modelChange)="model = $event; filterBySearch()" [(model)]="model"></cmp-input-date>
  </ng-template>

  <!--******* END DATA BY DATE FORMAT *******-->

  <!--******* INIT INPUT BY DROPDOWN *******-->
  <ng-template [ngSwitchCase]="enum_type_data.DROPDOWN">
    <cmp-input-dropdown [arrayValue]="key.value_DROPDOWN"
                        [(model)]="model"
                        (modelChange)="model= $event; filterBySearch()"
                        [title]="'...'">
    </cmp-input-dropdown>
  </ng-template>

  <!--******* END INPUT BY DROPDOWN *******-->

  <!--******* ACTION BUTTON*******-->
  <ng-template [ngSwitchCase]="enum_type_data.ACTION">
    <button class="btn btn-xs rounded-circle btn-{{key.type_action}}" (click)="filterBySearch()">
      <i *ngIf="key.icon" [class]="key.icon"></i>
      <!--<span *ngIf="key.title">{{key.title}}</span>-->
    </button>
  </ng-template>

  <!--******* END ACTION BUTTON*******-->
  <ng-template ngSwitchDefault>
    <cmp-input (modelChange)="model= $event; filterBySearch()" [(model)]="model"></cmp-input>
  </ng-template>
</div>
`,
  styles: [``]
})
export class InputTableComponent extends TableBase implements OnInit {


  @Output() modelChange = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
  }

  clickBoolCustom() {
    if (this.key.type_data === TYPE_DATA.BOOLEAN && this.key.value_DROPDOWN && this.key.value_DROPDOWN.length) {
      const aux0 = this.key.value_DROPDOWN.filter(e => e.value === this.model)[0];
      const index = this.key.value_DROPDOWN.indexOf(aux0);
      let item = null;
      if (index < (this.key.value_DROPDOWN.length - 1)) {
        item = this.key.value_DROPDOWN[index + 1].value;
      }
      if (this.key.type_data === TYPE_DATA.BOOLEAN) {
        item = this.model !== true;
      }
      this.model = item;
      this.modelChange.emit(this.model);
      this.filterBySearch();
    }
  }

}
